import { getQuerySet, getQueryParam, getHash } from '@didi/mfe-querystr';
import Data from '../data';
/**
 * Class for parsing url
 */
var Url = /** @class */ (function () {
    function Url() {
    }
    /**
     * Check whether a str is url
     * @param url
     */
    Url.isUrl = function (url) {
        var rUrl = /(https?:)?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
        var regex = new RegExp(rUrl);
        if (url && typeof url === 'string' && url.match(regex)) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Splice link with given params
     * @param url
     */
    Url.spliceUrl = function (baseUrl, params) {
        if (baseUrl === void 0) { baseUrl = ''; }
        if (params === void 0) { params = {}; }
        var url = baseUrl + "?";
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var value = typeof params[key] === 'object'
                    ? JSON.stringify(params[key])
                    : params[key];
                url += key + "=" + (encodeURIComponent(value) || '') + "&";
            }
        }
        return url.substring(0, url.length - 1);
    };
    /**
     * Get query params
     */
    /* istanbul ignore next */
    Url.getQuerySet = function () {
        return getQuerySet();
    };
    /**
     * Get query param by key
     */
    /* istanbul ignore next */
    Url.getQueryParam = function (key) {
        return getQueryParam(key);
    };
    /**
     * Get hash
     */
    /* istanbul ignore next */
    Url.getHash = function () {
        return getHash();
    };
    /**
     * Merge query params
     * @param href
     * @param params
     */
    Url.mergeQueryParam = function (href, params) {
        if (href === void 0) { href = ''; }
        if (params === void 0) { params = {}; }
        if (!href) {
            return '';
        }
        var _hash = '';
        var getParams = function (url) {
            var _params = {};
            var _paramItems = [];
            if (~url.indexOf('?')) {
                url = url.substr(1);
                /* istanbul ignore if */
                if (~url.indexOf('#')) {
                    _hash = url.split('#')[1];
                    url = url.split('#')[0];
                }
                _paramItems = url.split('&');
                _paramItems.forEach(function (item) {
                    var itemArray = item ? item.split('=') : null;
                    // 发现重复参数的时候只取第一个，因为乘客端通过中间页打开端的时候，端里面会给 url 里面加一个 token！不管原 url 有没有... f**k....
                    if (itemArray && !params[itemArray[0]]) {
                        _params[itemArray[0]] = itemArray[1] ? decodeURIComponent(itemArray[1]) : '';
                    }
                });
            }
            return _params;
        };
        var newParms = {};
        var oldParms = getParams("?" + href.split('?')[1]);
        if (~href.indexOf('?')) {
            newParms = Data.extend(oldParms, params);
            href = href.split('?')[0];
        }
        else {
            newParms = params;
        }
        href += '?';
        for (var i in newParms) {
            if (newParms.hasOwnProperty(i)) {
                href += i + "=" + newParms[i] + "&";
            }
        }
        href = href.substring(0, href.length - 1);
        /* istanbul ignore if */
        if (_hash) {
            href += "#" + _hash;
        }
        return href;
    };
    return Url;
}());
export default Url;
